import script from "./PublicAIGamePlay.vue?vue&type=script&setup=true&lang=js"
export * from "./PublicAIGamePlay.vue?vue&type=script&setup=true&lang=js"

import "./PublicAIGamePlay.vue?vue&type=style&index=0&id=44c9ced1&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44c9ced1"]])

export default __exports__